/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMoodSad2 = createReactComponent("mood-sad-2", "IconMoodSad2", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M14.5 16.05a3.5 3.5 0 0 0 -5 0", key: "svg-1" }],
  ["path", { d: "M10 9.25c-.5 1 -2.5 1 -3 0", key: "svg-2" }],
  ["path", { d: "M17 9.25c-.5 1 -2.5 1 -3 0", key: "svg-3" }]
]);

export { IconMoodSad2 as default };
//# sourceMappingURL=IconMoodSad2.js.map
